export const messages = {
  en: {
    housekeepingServPoolPayOrder: {
      title: 'Payment Order',
      feeCategory: 'Fee Category',
      feeName: 'Fee Name',
      chargeAmount: 'Charge Amount',
      actualAmount: 'Actual Amount',
      status: 'Status',
      unpaid: 'Unpaid',
      paid: 'Paid',
      paymentAmount: 'Payment Amount',
      payment: 'Payment',
      paymentQRCode: 'Payment QR Code',
      paymentComplete: 'Payment Complete'
    }
  },
  zh: {
    housekeepingServPoolPayOrder: {
      title: '支付订单',
      feeCategory: '费用大类',
      feeName: '费用名称',
      chargeAmount: '收费金额',
      actualAmount: '实收金额',
      status: '状态',
      unpaid: '未支付',
      paid: '已支付',
      paymentAmount: '缴费金额',
      payment: '缴费',
      paymentQRCode: '缴费二维码',
      paymentComplete: '支付完成'
    }
  }
}